import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { OverlayModule } from '@angular/cdk/overlay';
import { PortalModule } from '@angular/cdk/portal';

import { McRAIButtonModule } from '../button/button.module';
import { McRAIIconModule } from '../icon/icon.module';
import { McRAIModalHeader } from './directives/modal-header.directive';
import { McRAIModalContent } from './directives/modal-content.directive';
import { McRAIModalActions } from './directives/modal-actions.directive';
import { McRAIModalComponent } from './components/modal/modal.component';
import { McRAIModal } from './services/modal.service';

@NgModule({
  imports: [
    CommonModule,
    OverlayModule,
    PortalModule,
    McRAIButtonModule,
    McRAIIconModule
  ],
  declarations: [
    McRAIModalComponent,
    McRAIModalHeader,
    McRAIModalContent,
    McRAIModalActions
  ],
  exports: [
    McRAIModalHeader,
    McRAIModalContent,
    McRAIModalActions,
    McRAIModalComponent
  ],
  providers: [
    McRAIModal
  ]
})
export class McRAIModalModule { }
